/**
 * Copyright © 1998 - 2020 Tencent. All Rights Reserved.
 */
import * as pure from './pure';
import { compareVersion, getUserAgent, getVersionFromUA } from './util';
export { getVersionFromUA, compareVersion, };
var UserAgent = /** @class */ (function () {
    function UserAgent(userAgent) {
        if (userAgent === void 0) { userAgent = getUserAgent(); }
        var _this = this;
        /**
         * 获取 Android 版本
         */
        this.getAndroidVersion = function () {
            return pure.getAndroidVersion(_this.userAgent);
        };
        /**
         * 判断 Android 是否高于指定的版本
         */
        this.isAndroidVersionAboveOrEqual = function (version) {
            return pure.isAndroidVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 Harmony 版本
         */
        this.getHarmonyVersion = function () {
            return pure.getHarmonyVersion(_this.userAgent);
        };
        /**
         * 判断 Harmony 是否高于指定的版本
         */
        this.isHarmonyVersionAboveOrEqual = function (version) {
            return pure.isHarmonyVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 iOS 版本
         */
        this.getIOSVersion = function () {
            return pure.getIOSVersion(_this.userAgent);
        };
        /**
         * 判断 IOS 是否高于指定的版本
         */
        this.isIOSVersionAboveOrEqual = function (version) {
            return pure.isIOSVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 PC QQ 浏览器版本
         */
        this.getPCQQBrowserVersion = function () {
            return pure.getPCQQBrowserVersion(_this.userAgent);
        };
        /**
         * 判断 PC QQ 浏览器是否高于指定的版本
         */
        this.isPCQQBrowserVersionAboveOrEqual = function (version) {
            return pure.isPCQQBrowserVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取移动端 QQ 浏览器版本
         */
        this.getMobileQQBrowserVersion = function () {
            return pure.getMobileQQBrowserVersion(_this.userAgent);
        };
        /**
         * 判断移动端 QQ 浏览器是否高于指定的版本
         */
        this.isMobileQQBrowserVersionAboveOrEqual = function (version) {
            return pure.isMobileQQBrowserVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 Chrome 版本
         * 注意不代表一定是 Chrome H5，也可能是 Chrome 内核的 Android 客户端 H5、浏览器、小程序等，如果没有 Chrome 内核则为 null
         */
        this.getChromeVersion = function () {
            return pure.getChromeVersion(_this.userAgent);
        };
        /**
         * 判断 Chrome 是否高于指定的版本
         * 支持 Chrome 内核的 Android 客户端 H5、浏览器、小程序等，如果没有 Chrome 内核则为 false
         */
        this.isChromeVersionAboveOrEqual = function (version) {
            return pure.isChromeVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
       * 获取 safari 的版本
       */
        this.getSafariVersion = function () {
            return pure.getSafariVersion(_this.userAgent);
        };
        /**
         * 判断 safari 是否高于指定的版本
         */
        this.isSafariVersionAboveOrEqual = function (version) {
            return pure.isSafariVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 Firefox 的版本
         */
        this.getFirefoxVersion = function () {
            return pure.getFirefoxVersion(_this.userAgent);
        };
        /**
         * 判断 Firefox 是否高于指定的版本
         */
        this.isFirefoxVersionAboveOrEqual = function (version) {
            return pure.isFirefoxVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取微信版本
         * 同时支持微信 H5 和小程序 webview
         */
        this.getWeChatVersion = function () {
            return pure.getWeChatVersion(_this.userAgent);
        };
        /**
         * 判断微信是否高于指定的版本
         * 同时支持微信 H5 和小程序 webview
         */
        this.isWeChatVersionAboveOrEqual = function (version) {
            return pure.isWeChatVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 判断企业微信定制 CEF 版本是否高于指定的版本
         */
        this.isWxWorkCEFVersionAboveOrEqual = function (version) {
            return pure.isWxWorkCEFVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取微盘版本
         */
        this.getWxDriveVersion = function () {
            return pure.getWxDriveVersion(_this.userAgent);
        };
        /**
         * 判断微盘版本是否高于指定的版本
         */
        this.isWxDriveVersionAboveOrEqual = function (version) {
            return pure.isWxDriveVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取企业微信版本
         */
        this.getWxWorkVersion = function () {
            return pure.getWxWorkVersion(_this.userAgent);
        };
        /**
         * 判断企业微信是否高于指定的版本
         */
        this.isWxWorkVersionAboveOrEqual = function (version) {
            return pure.isWxWorkVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取私有化企业微信版本
         */
        this.getWxWorkPrivateVersion = function () {
            return pure.getWxWorkPrivateVersion(_this.userAgent);
        };
        /**
         * 判断私有化企业微信是否高于指定的版本
         */
        this.isWxWorkPrivateVersionAboveOrEqual = function (version) {
            return pure.isWxWorkPrivateVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 QQ 版本
         * 同时支持 QQ H5 和小程序 webview
         */
        this.getQQVersion = function () {
            return pure.getQQVersion(_this.userAgent);
        };
        /**
         * 判断 QQ 是否高于指定的版本
         * 同时支持 QQ H5 和小程序 webview
         */
        this.isQQVersionAboveOrEqual = function (version) {
            return pure.isQQVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取 TIM 版本
         */
        this.getTimVersion = function () {
            return pure.getTimVersion(_this.userAgent);
        };
        /**
         * 判断 TIM 是否高于指定的版本
         */
        this.isTimVersionAboveOrEqual = function (version) {
            return pure.isTimVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取腾讯文档移动客户端版本
         */
        this.getTencentDocsAppVersion = function () {
            return pure.getTencentDocsAppVersion(_this.userAgent);
        };
        /**
         * 判断腾讯文档移动客户端是否高于指定的版本
         */
        this.isTencentDocsAppVersionAboveOrEqual = function (version) {
            return pure.isTencentDocsAppVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取腾讯文档 PC 客户端版本
         * @deprecated 此为老的 Windows 客户端，现在已经不再使用，判断新客户端请改用 getElectronTencentDocsClientVersion
         */
        this.getPCTencentDocsClientVersion = function () {
            return pure.getPCTencentDocsClientVersion(_this.userAgent);
        };
        /**
         * 判断腾讯文档 PC 客户端是否高于指定的版本
         * @deprecated 此为老的 Windows 客户端，现在已经不再使用，判断新客户端请改用 isElectronTencentDocsClientVersionAboveOrEqual
         */
        this.isPCTencentDocsClientVersionAboveOrEqual = function (version) {
            return pure.isPCTencentDocsClientVersionAboveOrEqual(version, _this.userAgent);
        };
        /**
         * 获取腾讯文档 Electron 客户端版本
         */
        this.getElectronTencentDocsClientVersion = function () {
            return pure.getElectronTencentDocsClientVersion(_this.userAgent);
        };
        /**
         * 判断腾讯文档 Electron 客户端是否高于指定的版本
         */
        this.isElectronTencentDocsClientVersionAboveOrEqual = function (version) {
            return pure.isElectronTencentDocsClientVersionAboveOrEqual(version, _this.userAgent);
        };
        // 桌面端获取UA设置使用
        this.getBitToggleSettings = function (option) {
            return pure.getBitToggleSettings(option);
        };
        // 一旦构造，禁止动态修改，防止出错
        Object.defineProperty(this, 'userAgent', {
            value: userAgent,
            writable: false,
        });
    }
    Object.defineProperty(UserAgent.prototype, "isMobile", {
        /** *******************************************************************************
         * 一、硬件级别判断
         *********************************************************************************/
        /**
         * 是否是移动端, iPad 和 Android Pad 包含在移动端
         */
        get: function () {
            return pure.isMobile(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isMobilePhone", {
        /**
         * 是否是手机端
         */
        get: function () {
            return pure.isMobilePhone(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isIPhone", {
        /**
         * 是否是 iPhone
         */
        get: function () {
            return pure.isIPhone(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isIPad", {
        /**
         * 是否是 iPad
         */
        get: function () {
            return pure.isIPad(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isAndroidPhone", {
        /**
         * 是否是 Android 手机
         */
        get: function () {
            return pure.isAndroidPhone(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isAndroidPad", {
        /**
         * 是否是 Android 平板
         */
        get: function () {
            return pure.isAndroidPad(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isHarmonyPhone", {
        /**
         * 是否是 Harmony 手机
         */
        get: function () {
            return pure.isHarmonyPhone(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isHarmonyPad", {
        /**
         * 是否是 Harmony 手机
         */
        get: function () {
            return pure.isHarmonyPad(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isPC", {
        /**
         * 是否是 PC 或 Mac 设备
         */
        get: function () {
            return pure.isPC(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isMac", {
        /**
         * 是否是 Mac 电脑
         */
        get: function () {
            return pure.isMac(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isIPadEmulatedMac", {
        /**
         * 是否是 iPad 模拟的 Mac
         *
         * 背景：iPad OS 13 以上的 Safari 浏览器会默认模拟 Mac，UA 与 Mac 完全一致，这种情况前端可以通过触摸特性来判断，后端完全不可判断。
         * 为了防止判断为 iPad 导致与后端返回的 html 等资源产生平台不一致，我们仍然默认认为它是一个 Mac（`isMac` 为 `true`、`isIPad` 为
         * `false`），但同时也给出判断方法，用于前端微小逻辑的区分。
         *
         * Safari 浏览器的这个特性可以通过点击地址栏左侧的 “AA” 按钮 - “请求桌面网站” 来临时关闭，或者到 “网站设置” 中对当前域名长期关闭。
         *
         * 品类使用 DWS 插件 ipad-safari（https://git.woa.com/dws/dws-plugins-market/ipad-safari/）可以将这种情况改为下发 pad 端的制品，
         * 并能够自动修改 UserAgent 将其正确还原为 pad 端。
         */
        get: function () {
            return pure.isIPadEmulatedMac(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isAndroid", {
        /** *******************************************************************************
         * 二、操作系统级别判断
         *********************************************************************************/
        /**
         * 是否是 Android 平台
         */
        get: function () {
            return pure.isAndroid(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isHarmony", {
        /**
         * 是否是 Harmony 平台
         */
        get: function () {
            return pure.isHarmony(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isIOS", {
        /**
         * 是否是 iOS 平台
         */
        get: function () {
            return pure.isIOS(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWindows", {
        /**
         * 是否是 Windows 平台
         */
        get: function () {
            return pure.isWindows(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWindowsUWP", {
        /**
         * 是否在 Windows Store 的 UWP 软件上运行
         */
        get: function () {
            return pure.isWindowsUWP(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isLinux", {
        /**
         * 是否是 Linux 系统（不含安卓）
         */
        get: function () {
            return pure.isLinux(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isLinuxKylin", {
        /**
         * 是否是麒麟 Linux 系统
         */
        get: function () {
            return pure.isLinuxKylin(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isLinuxUOS", {
        /**
         * 是否是统信 Linux 系统
         */
        get: function () {
            return pure.isLinuxUOS(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isPCQQBrowser", {
        /** *******************************************************************************
         * 三、浏览器/浏览器内核级别判断
         *********************************************************************************/
        /**
         * 是不是 PC 上的 QQ 浏览器
         * 会自动排除 PC QQ
         */
        get: function () {
            return pure.isPCQQBrowser(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isMobileQQBrowser", {
        /**
         * 是不是移动端上的 QQ 浏览器
         * 会自动排除 QQ / TIM / 微信 / 企业微信 / 独立 App / 腾讯会议
         */
        get: function () {
            return pure.isMobileQQBrowser(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isQQBrowser", {
        /**
         * 是否是 QQ 浏览器
         */
        get: function () {
            return pure.isQQBrowser(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isHarmonyBrowser", {
        /**
         * 是否是 Harmony 内置浏览器
         */
        get: function () {
            return pure.isHarmonyBrowser(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isChrome", {
        /**
         * 是否是 Chrome 浏览器
         */
        get: function () {
            return pure.isChrome(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isSafari", {
        /**
         * 是否是 Safari 浏览器
         */
        get: function () {
            return pure.isSafari(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isIE", {
        /**
         * 是否是 IE 浏览器
         */
        get: function () {
            return pure.isIE(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isOldEdge", {
        /**
         * 是否是旧版 Edge 浏览器
         */
        get: function () {
            return pure.isOldEdge(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isChromiumEdge", {
        /**
         * 是否是新版 Chromium Edge 浏览器
         */
        get: function () {
            return pure.isChromiumEdge(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isFirefox", {
        /**
         * 是否是 Firefox 浏览器
         */
        get: function () {
            return pure.isFirefox(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWeChat", {
        /** *******************************************************************************
         * 四、微信/企业微信 H5 判断
         *********************************************************************************/
        /**
         * 是否是微信 H5
         * 自动排除企业微信和微信小程序
         */
        get: function () {
            return pure.isWeChat(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxWork", {
        /**
         * 是否是企业微信
         * 注意：包含企业微信小程序
         */
        get: function () {
            return pure.isWxWork(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxWorkQt", {
        /**
         * 是否是Qt版企业微信
         */
        get: function () {
            return pure.isWxWorkQt(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxWorkCustom", {
        /**
         * @deprecated 企微 macOS 用了这个 ua，但是 Windows 没有用。请使用 isWxWorkCEF 代替
         * 判断是否是企业微信的定制客户端
         */
        get: function () {
            return pure.isWxWorkCustom(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxWorkCEF", {
        /**
         * 判断是否是企业微信的定制 CEF 浏览器
         */
        get: function () {
            return pure.isWxWorkCEF(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 获取企业微信定制 CEF 版本
     */
    UserAgent.prototype.getWxWorkCEFVersion = function () {
        return pure.getWxWorkCEFVersion(this.userAgent);
    };
    Object.defineProperty(UserAgent.prototype, "isWxWorkPrivate", {
        /**
         * 是否是私有化企业微信
         */
        get: function () {
            return pure.isWxWorkPrivate(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxDrive", {
        /**
         * 判断是否是微盘
         */
        get: function () {
            return pure.isWxDrive(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isQQ", {
        /** *******************************************************************************
         * 五、QQ/TIM H5 判断
         *********************************************************************************/
        /**
         * 是否是 QQ H5
         * 会自动排除文档独立 App / 企业微信 / 微信 / QQ 浏览器 / TIM
         */
        get: function () {
            return pure.isQQ(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isQQForGooglePlay", {
        /**
         * 是否是 Google Play QQ
         * 注意：包含 QQ 小程序
         */
        get: function () {
            return pure.isQQForGooglePlay(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTim", {
        /**
         * 是否是 TIM
         * 注意：包含 TIM 小程序
         */
        get: function () {
            return pure.isTim(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isPCTim", {
        /**
         * 是否是 PC 端的 TIM
         */
        get: function () {
            return pure.isPCTim(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTimOrQQ", {
        /**
         * 是否是 TIM 或者 QQ H5
         * 注意：不包含 QQ/TIM 小程序
         */
        get: function () {
            return pure.isTimOrQQ(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTimOrQQFamily", {
        /**
         * 是否属于 TIM 或者泛 QQ 家族
         * 注意：原来的 isQQFamily 和这个含义一样
         */
        get: function () {
            return pure.isTimOrQQFamily(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isQQDesktopDocsClient", {
        /**
        * 是否在 QQ mini 端（QQ 预览文档平台，可以理解为 QQ 桌面端内嵌的文档客户端）
        */
        get: function () {
            return pure.isQQDesktopDocsClient(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isMiniProgram", {
        /** *******************************************************************************
         * 六、小程序（webview/原生）判断
         *********************************************************************************/
        /**
         * 是否是（微信/企业微信或 QQ/TIM）的小程序 webview
         */
        get: function () {
            return pure.isMiniProgram(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxMiniProgram", {
        /**
         * 是否是微信/企业微信小程序 webview
         */
        get: function () {
            return pure.isWxMiniProgram(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isQQMiniProgram", {
        /**
         * 是否是 QQ/TIM 小程序 webview
         */
        get: function () {
            return pure.isQQMiniProgram(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTencentDocsApp", {
        /** *******************************************************************************
         * 七、独立 App 判断
         *********************************************************************************/
        /**
         * 是否是移动客户端
         */
        get: function () {
            return pure.isTencentDocsApp(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isPCTencentDocsClient", {
        /**
         * 是否是 PC 客户端
         * @deprecated 此为老的 Windows 客户端，现在已经不再使用，判断新客户端请改用 isElectronTencentDocsClient
         */
        get: function () {
            return pure.isPCTencentDocsClient(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isPCTencentDocsApp", {
        /**
         * 是否是 PC 客户端
         * @deprecated 此为老的 Windows 客户端，现在已经不再使用，判断新客户端请改用 getElectronTencentDocsClientVersion
         */
        get: function () {
            return pure.isPCTencentDocsApp(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isElectronTencentDocsClient", {
        /**
         * 是否是 Electron 客户端
         */
        get: function () {
            return pure.isElectronTencentDocsClient(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isMacAppStoreTencentDocsClient", {
        /**
         * 是否是腾讯文档 PC 客户端 MacAppStore 版本
         */
        get: function () {
            return pure.isMacAppStoreTencentDocsClient(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWeiYunApp", {
        /**
         * 是否是微云 App
         */
        get: function () {
            return pure.isWeiYunApp(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isSouGou", {
        /**
         * 是否是搜狗 windows 浏览器
         */
        get: function () {
            return pure.isSouGou(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTencentMeeting", {
        /**
         * 是否是腾讯会议
         */
        get: function () {
            return pure.isTencentMeeting(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isWxWorkTencentMeeting", {
        /**
         * 是否是企微内腾讯会议
         */
        get: function () {
            return pure.isWxWorkTencentMeeting(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isTencentMeetingRooms", {
        /**
         * 是否是腾讯会议的 Rooms 客户端（rooms 是腾讯会议的一个细分场景：嵌入式 app，常常嵌入在会议室的电子白板）
         */
        get: function () {
            return pure.isTencentMeetingRooms(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isSupportNativeDatabase", {
        /**
         * 是否支持客户端数据库
         */
        get: function () {
            return pure.isSupportNativeDatabase(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isSupportFullOfflineMode", {
        /**
         * 是否支持全离线能力(离线编辑&离线打开)
         */
        get: function () {
            return pure.isSupportFullOfflineMode(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAgent.prototype, "isNativeDatabaseWillDeprecated", {
        /**
         * 客户端数据库是否即将废弃
         */
        get: function () {
            return pure.isNativeDatabaseWillDeprecated(this.userAgent);
        },
        enumerable: false,
        configurable: true
    });
    return UserAgent;
}());
export { UserAgent };
export default new UserAgent();
